<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import { useAbility } from "@/api/models/auth/ability";
import { canOpenBillingPage, readBillingRights } from "@/composables/shared/billingAccess";
import BillingShell from "@/components/models/billing/BillingShell.vue";
import MsoPaymentMethodsCard from "@/components/models/billing/MsoPaymentMethodsCard.vue";
import CompanyPaymentMethodsCard from "@/components/models/billing/CompanyPaymentMethodsCard.vue";

definePage({
  meta: {
    title: "generic.fields.sections.paymentMethods",
    checkPrivileges: () => {
      const { can } = useAbility();
      return canOpenBillingPage(readBillingRights(can), "payment-methods");
    },
  },
});
</script>

<template>
  <billing-shell page="payment-methods">
    <template #default="{ scope, mso, company, canManageBilling }">
      <mso-payment-methods-card
        v-if="scope === 'mso' && mso"
        :mso-id="mso.id"
        :can-manage="canManageBilling"
      />

      <company-payment-methods-card
        v-else-if="scope === 'company' && company"
        :key="`company-${company.id}`"
        :company-id="company.id"
        :can-manage="canManageBilling"
      />
    </template>
  </billing-shell>
</template>
